import MuiInputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';

export const StyledInputAdornment = styled(MuiInputAdornment)({}) as typeof MuiInputAdornment;
